import Footer from "./Footer";
import Header from "./Header";
import Main from "./Main";

const Home = () => {
  return (
    <div>
      <Header />
      <Main />
      <Footer />
    </div>
  );
};

export default Home;
